export default "__VITE_PUBLIC_ASSET__501b4d4c__"